import axios from 'axios';
import { API_URL } from '../config';

export const importEmployees = async (token: string, file: any, companyId: number) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(`${API_URL}/import/employees/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `${token}`,  
        },
    });
    return response.data;
};

export const downloadTemplate = async (token: string) => {
    const response = await axios.get(`${API_URL}/import/template/employee/`, {
        headers: {
            'Authorization': `${token}`,
            'Content-Type': 'application/csv',
        },
        responseType: 'blob',
    });

    
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `template_employee.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const fetchInstructions = async (token: string) => {
    const response = await axios.get(`${API_URL}/import/employees/`, {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};
